"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toObjectChainReduceRecipe = void 0;
const prepare_1 = require("../types-internal/prepare");
function unwindAndGroup(it, ing, key) {
    it = ing.flatten.call(it, (x) => {
        const current = key(x);
        return typeof current !== 'string' &&
            typeof current[Symbol.iterator] === 'function'
            ? ing.map.call(current, (item) => [item, x])
            : [[current, x]];
    });
    return ing.group.call(it, (x) => x[0], (_k, v) => [v[1]]);
}
function toObjectNode(it, keys, index, ing, reducer, initial) {
    const key = keys[index];
    it = unwindAndGroup(it, ing, key);
    return ing.toObject.call(it, 'key', index < keys.length - 1
        ? (subIt) => toObjectNode(subIt.values, keys, index + 1, ing, reducer, initial)
        : (subIt) => ing.reduce.call(subIt.values, reducer, initial()));
}
function toObjectChainReduceRecipe(ing) {
    return function (initial, reducer, ...keys) {
        const prepared = keys.map((x) => (0, prepare_1.prepare)(x));
        return keys.length === 0
            ? ing.reduce.call(this, reducer, initial())
            : toObjectNode(this, prepared, 0, ing, reducer, initial);
    };
}
exports.toObjectChainReduceRecipe = toObjectChainReduceRecipe;
